import { useEffect, useRef } from 'react';
import giftHtml from './gift/gift.html?raw';
import './gift/gift.css';
import { mountGift } from './gift/gift';

/**
 * ember.space/gift (2026-10-20 founder): give Ember to someone you love. The
 * product shown first is the conversation (app screens, the note writer, a try
 * of Ember itself); Little Ember and the Ember Book are what comes in the box.
 * The markup is authored HTML (gift/gift.html) under a `.gift` root whose CSS
 * is scoped to it; gift/gift.ts wires the behaviour once the page is in the
 * DOM. Checkout opens in the next phase — the buy sheet says so.
 */
const FONTS = 'https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;1,6..72,400&family=Caveat:wght@500&display=swap';

export default function GiftPage() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!document.querySelector(`link[href="${FONTS}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = FONTS;
      document.head.appendChild(link);
    }
    return ref.current ? mountGift(ref.current) : undefined;
  }, []);
  return <div ref={ref} className="gift" dangerouslySetInnerHTML={{ __html: giftHtml }} />;
}
